module.exports = __webpack_public_path__ + "static/media/iconCloseTerms.a4b798ac.svg";